<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/day.png" /></div>
      <p>Day</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/day/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.10.7",
          linkList: [ur + "1.10.7/dayjs.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListDay.vue